import * as React from "react";
import type { SVGProps } from "react";
const SvgMicrophone02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M2.493 13.377a9.607 9.607 0 0 0 19.014 0M12.001 2.4a4.116 4.116 0 0 0-4.116 4.116v5.488a4.116 4.116 0 1 0 8.233 0V6.516A4.116 4.116 0 0 0 12 2.4"
    />
  </svg>
);
export default SvgMicrophone02;
